import classNames from 'classnames'

import { getQaSelector } from '../../../utils/common'
import { ICON_HEIGHT_40, IconNG, IconSpinner } from '../../Icon'
import Text from '../../Text'

import * as styles from './FileUploadPlaceholder.module.css'

import UploadIcon from '../../../icons/upload-2.svg'

function FileUploadPlaceholder({
  Icon = UploadIcon,
  className = styles.FileUploadPlaceholder,
  disabled,
  error,
  iconClassName = styles.icon,
  iconSize = ICON_HEIGHT_40,
  loading,
  qaName,
  text,
  onClick,
}) {
  const uploadClassName = classNames(className, {
    [styles.disabled]: disabled,
    [styles.error]: error,
  })

  return (
    <div
      {...getQaSelector({ value: qaName })}
      className={uploadClassName}
      onClick={onClick}
    >
      {Icon && !loading ? (
        <IconNG Icon={Icon} className={iconClassName} size={iconSize} />
      ) : null}
      {loading ? (
        <IconSpinner className={iconClassName} size={iconSize} />
      ) : null}
      {text ? <Text className={styles.text}>{text}</Text> : null}
    </div>
  )
}

export default FileUploadPlaceholder
